import { useState } from 'react'
import type { SpaceSortOrder } from './space-sort.js'
import { defaultSpaceSortOrder, isSpaceSortOrder } from './space-sort.js'

/** Per viewer, per browser: how Home's Spaces section is ordered */
export const spacesSortStorageKey = 'tunasong.home.spacesSort'

const readStored = (): SpaceSortOrder => {
  try {
    const stored = window.localStorage.getItem(spacesSortStorageKey)
    return isSpaceSortOrder(stored) ? stored : defaultSpaceSortOrder
  } catch {
    return defaultSpaceSortOrder
  }
}

const writeStored = (order: SpaceSortOrder) => {
  try {
    window.localStorage.setItem(spacesSortStorageKey, order)
  } catch {
    // Storage blocked (private mode, quota): the choice still holds for this visit
  }
}

/** The Spaces sort order, remembered in localStorage; missing, blocked or unknown values fall back to Recent */
export const useSpacesSort = () => {
  const [order, setOrderState] = useState(readStored)
  const setOrder = (next: SpaceSortOrder) => {
    setOrderState(next)
    writeStored(next)
  }
  return [order, setOrder] as const
}
